import {
  Table as MuiTable,
  TableProps as MuiTableProps,
  TableRow as MuiTableRow,
  TableRowProps as MuiTableRowProps,
  TableCell as MuiTableCell,
  TableCellProps as MuiTableCellProps,
  SvgIcon as MuiSvgIcon,
  SvgIconProps as MuiSvgIconProps,
  darken,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const CollapseButtonCell = styled(MuiTableCell)<MuiTableCellProps>(
  ({ theme: { spacing } }) => ({
    padding: spacing(2.6, 0.8, 2.6, 1.6),
    cursor: 'pointer',
  })
);

export const CollapseIcon = styled(MuiSvgIcon)<MuiSvgIconProps>(
  ({ theme: { palette } }) => ({
    color: palette.secondary.main,
    verticalAlign: 'inherit',
  })
);

export const CollapseTable = styled(MuiTable)<MuiTableProps>(
  ({ theme: { customVars } }) => ({
    '&.CollapseTableParent': {
      boxShadow: customVars.dropDownShadow,
    },
  })
);

export const CollapsePrimaryRow = styled(MuiTableRow)<MuiTableRowProps>(
  ({ theme: { colors } }) => ({
    position: 'relative',
    backgroundColor: colors.tableExpandRow,
    cursor: 'pointer',
    zIndex: 10,
    '&:focus, &:hover': {
      backgroundColor: darken(colors.tableExpandRow as string, 0.1),
    },
  })
);
